import { useRouter } from "src/helpers"; // import lodash from 'lodash';
// import deepdash from 'deepdash-es';

import {
    withHookForChapter,
    withUpdateChapter,
} from "src/modules/book/operations";
import { compose } from "src/helpers";

import EditView from "./component";

const Edit = (props) => {
    const { updateChapter } = props;
    const router = useRouter();
    const {
        query: { book_id },
    } = router;

    const onFinish = async (values: any) => {
        await updateChapter(values);
        router.push(`/book/chapter/${book_id}`);
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return (
        <EditView
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            {...props}
        />
    );
};

export default compose(withHookForChapter, withUpdateChapter)(Edit);
